import { ClinicDTO } from './clinic';

export enum UserRole {
  admin = 'Admin',
}

export interface SystemUserDTO {
  clinicId: ClinicDTO['id'];
  sub: number;
  name: string;
  role: UserRole;
}

export default class SystemUser {
  clinicId: ClinicDTO['id'];
  id: number;
  name: string;
  role: UserRole;

  constructor(dto: Partial<SystemUserDTO>) {
    this.update({ id: dto.sub, role: dto.role, name: dto.name, clinicId: dto.clinicId });
  }

  get asJson(): SystemUserDTO {
    return {
      clinicId: this.clinicId,
      sub: this.id,
      name: this.name,
      role: this.role,
    };
  }

  update(newData: Partial<SystemUser>) {
    Object.assign(this, newData);

    return this.asJson;
  }
}
